export default function Features() {
	return (
		<section class="preflop-section">
			<h1>Ready to Master the Preflop?</h1>

			<div class="feature">
				<i class="fas fa-bullseye icon"></i>
				<p>Range Trainer – Drill hundreds of spots with instant GTO feedback</p>
			</div>

			<div class="feature">
				<i class="fas fa-chess-queen icon"></i>
				<p>Range Display – Study optimal ranges for every position &amp; scenario</p>
			</div>

			<div class="feature">
				<i class="fas fa-chart-line icon"></i>
				<p>Training Data – Track your reps, plug leaks, and see your progress</p>
			</div>

			<div class="feature">
				<i class="fas fa-users icon"></i>
				<p>Useful at All Levels – Whether you're just starting out or deep in the grind</p>
			</div>

			<div class="feature">
				<i class="fas fa-rocket icon"></i>
				<p>Focused Training – Build precision, confidence, and edge</p>
			</div>

			<div class="feature">
				<i class="fas fa-unlock icon"></i>
				<p>7-Day Free Trial – No credit card required</p>
			</div>
		</section>
	);
}
